<div class="days-row">
  @for (dayInMonth of daysInMonth; track dayInMonth; let day = $index) {
    <div class="days-row__item">
      <app-selectable-card
        [id]="'day-' + (day + 1)"
        [text]="day + 1"
        [selected]="days.includes(day + 1)"
        (click)="toggleDay(day + 1)">
      </app-selectable-card>
    </div>
  }
</div>
